import styled from 'styled-components';

export const StyledLink = styled.a<{ isActive: boolean }>`
  cursor: pointer;
  display: inline-block;
  padding: ${(props) => props.theme.spacing.spacing5};
  outline-color: ${(props) => props.theme.colors.primary};
  ${(props) => (props.isActive ? `border-bottom: 3px solid ${props.theme.colors.primary};` : ``)}
`;
